// components/MonthPicker.js
import React, { useState } from 'react';
import dayjs from 'dayjs';

const MonthPicker = ({ onMonthChange }) => {
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [startDate, setStartDate] = useState(dayjs().startOf('month').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(dayjs().endOf('month').format('YYYY-MM-DD'));

  const handlePreviousMonth = () => {
    const newDate = selectedDate.subtract(1, 'month');
    setSelectedDate(newDate);
    updateDates(newDate);
  };

  const handleNextMonth = () => {
    const newDate = selectedDate.add(1, 'month');
    setSelectedDate(newDate);
    updateDates(newDate);
  };

  const updateDates = (date) => {
    const startDate = date.startOf('month').format('YYYY-MM-DD');
    const endDate = date.endOf('month').format('YYYY-MM-DD');
    onMonthChange(startDate, endDate);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
      <button onClick={handlePreviousMonth}>{'<'}</button>
      <h3 style={{ margin: '0 15px' }}>{selectedDate.format('MMMM YYYY')}</h3>
      <button onClick={handleNextMonth}>{'>'}</button>
    </div>
  );
};

export default MonthPicker;
